export enum OriginTypeEnumDTO {
    Billing = "Billing",
    Admin = "Admin",
    Himself = "Himself",
    ByGuru = "ByGuru",
    IsGuru = "IsGuru",
    IsReviewer = "IsReviewer",
    IsCollaborator = "IsCollaborator",
    NotSpecified = "NotSpecified",
    Coupon = "Coupon",
    Plan = "Plan"
}
